import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { FaBars } from 'react-icons/fa';
import { FiChevronsLeft, FiChevronsRight, FiGlobe } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import '../styles/AppLayout.css';
import languageService from '../services/languageService';

const AppLayout = () => {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
	const { i18n } = useTranslation();

	const toggleMobileMenu = () => setIsMobileMenuOpen(v => !v);
	const closeMobileMenu = () => setIsMobileMenuOpen(false);
	const toggleSidebarCollapse = () => setIsSidebarCollapsed(v => !v);

	const toggleLanguage = () => {
		const currentLang = (i18n?.language || 'cs').slice(0, 2);
		const newLang = currentLang === 'cs' ? 'en' : 'cs';
		languageService.changeLanguageAndPersist(i18n, newLang);
	};

	return (
		<div className="app-layout">
			{/* MOBILE TOP BAR */}
			<header className="mobile-topbar">
				<div className="topbar-inner">

					<div className="topbar-title"><NavLink to="/">
						Scoreo
					</NavLink></div>
					<div className="topbar-actions">
						<button
							type="button"
							className="topbar-lang"
							onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleLanguage(); }}
							aria-label="Změnit jazyk"
							title="Změnit jazyk"
						>
							<FiGlobe />
						</button>
						<button
							type="button"
							className="topbar-burger"
							onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleMobileMenu(); }}
							aria-label={isMobileMenuOpen ? 'Zavřít menu' : 'Otevřít menu'}
							aria-expanded={isMobileMenuOpen}
							aria-controls="app-sidebar"
						>
							<FaBars />
						</button>
					</div>
				</div>
			</header>

			<Sidebar
				isMobileOpen={isMobileMenuOpen}
				onCloseMobile={closeMobileMenu}
				isCollapsed={isSidebarCollapsed}
				onToggleCollapse={toggleSidebarCollapse}
			/>

			{/* Desktop collapse tlačítko - mimo sidebar */}
			<button
				className="desktop-collapse-toggle"
				onClick={toggleSidebarCollapse}
				aria-label={isSidebarCollapsed ? 'Rozšířit sidebar' : 'Zmenšit sidebar'}
				title={isSidebarCollapsed ? 'Rozšířit sidebar' : 'Zmenšit sidebar'}
			>
				{isSidebarCollapsed ? <FiChevronsRight /> : <FiChevronsLeft />}
			</button>

			<main className={`main-content ${isMobileMenuOpen ? 'pushed' : ''} ${isSidebarCollapsed ? 'expanded' : ''}`}>
				<Outlet />
			</main>
		</div>
	);
};

export default AppLayout;
